import { render, staticRenderFns } from "./storePaw.vue?vue&type=template&id=be31b318&scoped=true&"
import script from "./storePaw.vue?vue&type=script&lang=js&"
export * from "./storePaw.vue?vue&type=script&lang=js&"
import style0 from "./storePaw.vue?vue&type=style&index=0&id=be31b318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be31b318",
  null
  
)

export default component.exports